import React, { useEffect, useMemo, useState } from 'react';
import Immutable from 'immutable';
import { CoreLink, UI_OPERATION_STATUS_SUCCESS } from '@uncinc/react-drupal-core';
import { useSelector } from 'react-redux';
import { usePrevious } from '../../helpers/usePrevious';
import { formatCartItemsForAnalytics } from '../../helpers/commerce';

const CartSummary = ({ setShowCartPopup }) => {
  const [initialLoadDone, setInitialLoadDone] = useState(false);

  const path = useSelector((state) => state.getIn(['router', 'location', 'pathname']));
  const commerce = useSelector((state) => state.get('commerce'));
  const cartLoaded = useSelector((state) => state.getIn(['ui', 'commerce', 'operations', 'cart_load', 'status']) === UI_OPERATION_STATUS_SUCCESS);
  const productAddStatus = useSelector((state) => state.getIn(['ui', 'commerce', 'operations', 'cart_product_add', 'status']));

  const numberOfProducts = useMemo(() => {
    return commerce.getIn(['cart', 'products'], Immutable.List()).reduce((carry, item) => {
      const qty = parseInt(item.getIn(['attributes', 'quantity'], 1));
      return carry + qty;
    }, 0);
  }, [commerce]);

  const analyticsItems = useMemo(() => {
    return formatCartItemsForAnalytics(commerce.getIn(['cart', 'products']));
  }, [commerce]);

  const totalPrice = commerce.getIn(['cart', 'content', 'attributes', 'order_total', 'subtotal', 'number'], 0);
  const prevNumberOfProducts = usePrevious(numberOfProducts);

  const cartIconClicked = () => {
    if (typeof window !== 'undefined' && numberOfProducts > 0) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'view_cart',
        ecommerce: {
          currency: 'EUR',
          value: totalPrice,
          items: analyticsItems,
        },
      });
    }
    setShowCartPopup((showCartPopup) => !showCartPopup);
  };

  // Then display the popup if there is a change in the number of products.
  useEffect(() => {
    if ((cartLoaded || initialLoadDone)) {
      if (!initialLoadDone) {
        setInitialLoadDone(true);
      }

      // We do not want to show the popup even on refresh, only when number of products has changed.
      if (
        (numberOfProducts !== 0 && numberOfProducts > prevNumberOfProducts) ||
        productAddStatus === UI_OPERATION_STATUS_SUCCESS
      ) {
        const onlyElearningProductsPresent = commerce.getIn(['cart', 'products'], Immutable.List()).every((item) => item?.toJS().relationships.purchased_entity.type === 'product-variation--e-learning');

        if (setShowCartPopup && !path.startsWith('/cart') && !onlyElearningProductsPresent) {
          setShowCartPopup(true);
        }
      }
    }
  }, [cartLoaded, initialLoadDone, prevNumberOfProducts, numberOfProducts, setShowCartPopup, productAddStatus]);

  // Hide when empty.
  if (numberOfProducts === 0) {
    return null;
  }

  return (
    <CoreLink href="#" className="cart-icon" onClick={cartIconClicked}>
      {numberOfProducts
        ? <div className="icon icon-shopping-cart cart-icon__icon" />
        : <div className="icon icon-shopping-cart cart-icon__icon" />}
      <span className={`cart-icon__badge ${numberOfProducts ? '' : 'hide'}`}>{numberOfProducts}</span>
    </CoreLink>
  );
};

export default CartSummary;
